import { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import Jira from "../../../../services/Jira";
import DefectsAccessibilityModal from "../../../common/modals/DefectsAccessibilityModal";

export default function DefectCountAccessibilityChart({
  currentProjectId,
  token,
  currentIteration,
  event,
  setImageUrl,
}) {
  const options = {
    title: "Defect count by accessibility criteria",
    titleTextStyle: { fontSize: "16" },
    legend: { position: "bottom" },
  };

  const [dataTable, setDataTable] = useState([]);

  const [defectsMap, setDefectsMap] = useState([]);

  const [sprints, setSprints] = useState(null);

  const [showModal, setShowModal] = useState(false);

  const [modalData, setModalData] = useState([]);

  const chartEvents = [
    {
      eventName: "ready",
      callback: ({ chartWrapper, google }) => {
        var handler = async function () {
          const chart = chartWrapper.getChart();
          var selection = chart.getSelection();
          if (!selection || selection.length < 1) {
            return;
          }
          var row = selection[0].row + 1;

          const selected = dataTable[row][0];

          const data = [];

          if (currentIteration === "Overall") {
            if (sprints["0"] && sprints["0"][selected]) {
              const current = sprints["0"][selected];
              current.forEach((issue) => {
                const element = defectsMap.find(
                  (item) => item.issueId === issue
                );
                if (element) {
                  data.push({
                    issueID: element.issueId,
                    issueSummary: element.issueSummary,
                    status: element.status,
                    selfLink: element.selfLink,
                  });
                }
              });
            }
          } else {
            if (
              sprints[currentIteration] &&
              sprints[currentIteration][selected]
            ) {
              const current = sprints[currentIteration][selected];
              current.forEach((issue) => {
                const element = defectsMap.find(
                  (item) => item.issueId === issue
                );
                if (element) {
                  data.push({
                    issueID: element.issueId,
                    issueSummary: element.issueSummary,
                    status: element.status,
                    selfLink: element.selfLink,
                  });
                }
              });
            }
          }

          setModalData({
            title: `Defect count by accessibility criteria - ${selected}`,
            rows: data,
          });

          setShowModal(true);
        };

        google.visualization.events.addListener(
          chartWrapper.getChart(),
          "select",
          () => handler()
        );
      },
    },
  ];

  useEffect(() => {
    if (currentProjectId && token) {
      handleFetchAccessibilityDefectCount();
    }
  }, [currentProjectId, token]);

  const handleFetchAccessibilityDefectCount = async () => {
    const data = await Jira.getAccessibilityDefectCount(
      token,
      currentProjectId
    );
    setSprints(data.sprints);
    setDefectsMap(data.defectsMap);
  };

  useEffect(() => {
    if (sprints && defectsMap) {
      if (currentIteration === "Overall") {
        if (sprints["0"] && Object.keys(sprints["0"]).length > 0) {
          const table = [["Items", "Quantity"]];
          Object.keys(sprints["0"]).forEach((key) => {
            const value = sprints["0"][key].length;
            table.push([key, value]);
          });

          setDataTable(table);
        }
      } else {
        if (
          sprints[currentIteration] &&
          Object.keys(sprints[currentIteration]).length > 0
        ) {
          const table = [["Items", "Quantity"]];
          Object.keys(sprints[currentIteration]).forEach((key) => {
            const value = sprints[currentIteration][key].length;
            table.push([key, value]);
          });
          setDataTable(table);
        }
      }
    }
  }, [sprints, defectsMap, currentIteration]);

  if (event) {
    chartEvents.push({
      eventName: "ready",
      callback: ({ chartWrapper, google }) => {
        let url = chartWrapper.getChart().getImageURI();
        setImageUrl(url);
      },
    });
  }

  return (
    <div>
      <DefectsAccessibilityModal
        isOpen={showModal}
        setShowModal={setShowModal}
        data={modalData}
      />
      {dataTable.length === 0 && (
        <div
          className="flex justify-center items-center h-96"
          style={{
            minHeight: "400px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "white",
            position: "relative",
          }}
        >
          <p
            className="text-gray-500"
            style={{
              position: "absolute",
              top: "20px",
              left: "20px",
              fontWeight: "bold",
            }}
          >
            Defect count by accessibility criteria
          </p>
          <p className="text-gray-500">No data</p>
        </div>
      )}
      {dataTable.length > 0 && (
        <Chart
          chartType="BarChart"
          width="100%"
          height="800px"
          data={dataTable}
          options={options}
          chartEvents={chartEvents}
        />
      )}
    </div>
  );
}
